import { render } from "./PreRegisterView.vue?vue&type=template&id=266016dc&scoped=true"
import script from "./PreRegisterView.vue?vue&type=script&lang=js"
export * from "./PreRegisterView.vue?vue&type=script&lang=js"

import "./PreRegisterView.vue?vue&type=style&index=0&id=266016dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266016dc"]])

export default __exports__